import {
  DiscountCollection,
  DiscountHistory,
  DiscountHistoryEntry,
  DiscountInfo,
  DiscountsChangeHistory,
  Season,
} from 'types';
import { convertTimestampToDate } from 'helpers';

function populateCollections(data: any[] = []): DiscountCollection[] {
  return data.map(({ code, name, percentage }) => ({
    code: code ?? '',
    name: name ?? '',
    percentage: percentage ?? 0,
  }));
}

function populateSeason(data: any = {}): Season {
  const { code, name, collections, initialDate, finalDate } = data;

  return {
    code: code ?? '',
    name: name ?? '',
    collections: populateCollections(collections),
    initialDate: convertTimestampToDate(initialDate ?? 0),
    finalDate: convertTimestampToDate(finalDate ?? 0),
  };
}

export function discountFactory(params: any = {}): DiscountInfo {
  const {
    actualSeason,
    lastSeason,
    percentagePastSeasons,
    percentageTimelessSeasons,
  } = params;

  return {
    actualSeason: populateSeason(actualSeason),
    lastSeason: populateSeason(lastSeason),
    percentagePastSeasons: percentagePastSeasons ?? 0,
    percentageTimelessSeasons: percentageTimelessSeasons ?? 0,
  };
}

function populateDiscountHistoryEntries(
  params: any[] = []
): DiscountHistoryEntry[] {
  return params.map((param) => {
    const { discountType, newDiscount, oldDiscount, customDiscount } =
      param || {};

    return {
      discountType: discountType ?? '',
      newDiscount: newDiscount ?? '',
      oldDiscount: oldDiscount ?? '',
      customDiscount: customDiscount
        ? {
            collection: customDiscount.collection ?? '',
            season: customDiscount.season ?? '',
          }
        : undefined,
    };
  });
}

function populateDiscountsHistory(data: any[] = []): DiscountHistory[] {
  return data.map(({ changedBy, date, entries }) => ({
    changedBy: changedBy ?? '',
    date: convertTimestampToDate(date),
    entries: populateDiscountHistoryEntries(entries),
  }));
}

export function discountHistoryFactory(
  params: any = {}
): DiscountsChangeHistory {
  const { changeHistory } = params;

  return {
    changeHistory: populateDiscountsHistory(changeHistory),
  };
}
